// Module
var code = "<div class=\"td_container\"></div> <button class=\"loading transport-button\" aria-live=\"polite\"></button> <div class=\"volume-slider-container\" style=\"display:none\"><div class=\"volume-slider\" style=\"display:none\"></div></div> ";
// Exports
module.exports = code;